/*
 * Poofy — fonctionnalités du panier (drawer OCB)
 * Le drawer est entièrement re-rendu côté serveur à chaque mise à jour du panier :
 * on (ré)initialise les composants Poofy à chaque mutation du DOM.
 * Chargé via <script defer> depuis les snippets poofy-cart-* (garde anti double-chargement).
 */
(function () {
  if (window.PoofyCart) return;

  var KEY_LEVEL = 'poofy:tiers:level';
  var KEY_FILL = 'poofy:tiers:fill';
  var CONFETTI_COLORS = ['#C9986B', '#B86A4A', '#E8DFD2', '#6D5843', '#8F9779', '#FAF7F2'];

  function store(key, value) {
    try {
      if (value === undefined) return sessionStorage.getItem(key);
      sessionStorage.setItem(key, value);
    } catch (e) {
      return null;
    }
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ---------- Confettis (canvas, sans librairie) ---------- */
  function confetti(originEl) {
    if (prefersReducedMotion()) return;
    var canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:2147483647;';
    document.body.appendChild(canvas);
    var dpr = window.devicePixelRatio || 1;
    canvas.width = Math.round(window.innerWidth * dpr);
    canvas.height = Math.round(window.innerHeight * dpr);
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);

    var rect = originEl.getBoundingClientRect();
    var ox = rect.left + rect.width / 2;
    var oy = rect.top + 20;
    var parts = [];
    for (var i = 0; i < 90; i++) {
      var angle = Math.random() * Math.PI - Math.PI; // vers le haut
      var speed = 4 + Math.random() * 7;
      parts.push({
        x: ox + (Math.random() - 0.5) * rect.width * 0.6,
        y: oy,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - 2,
        w: 5 + Math.random() * 5,
        h: 8 + Math.random() * 6,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.3,
        color: CONFETTI_COLORS[i % CONFETTI_COLORS.length]
      });
    }

    var start = performance.now();
    var DURATION = 1800;
    function frame(now) {
      var t = now - start;
      // Efface en pixels réels (sinon, avec un zoom < 100 %, une partie de l'écran garde des traînées)
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var alpha = t > DURATION - 500 ? Math.max(0, (DURATION - t) / 500) : 1;
      parts.forEach(function (p) {
        p.vy += 0.25;
        p.vx *= 0.99;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        ctx.save();
        ctx.globalAlpha = alpha;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });
      if (t < DURATION) requestAnimationFrame(frame);
      else canvas.remove();
    }
    requestAnimationFrame(frame);
  }

  /* ---------- Barre de paliers ---------- */
  function initTiers(root) {
    var els = (root || document).querySelectorAll('[data-poofy-tiers]:not([data-poofy-ready])');
    els.forEach(function (el) {
      el.setAttribute('data-poofy-ready', '');
      var level = parseInt(el.dataset.level, 10) || 0;
      var target = parseFloat(el.dataset.fill) || 0;
      var prevLevel = store(KEY_LEVEL);
      var prevFill = store(KEY_FILL);
      var fillEl = el.querySelector('.poofy-tiers__fill');

      // Anime la barre depuis sa position précédente (le DOM vient d'être remplacé)
      if (fillEl && prevFill !== null && parseFloat(prevFill) !== target) {
        fillEl.style.transition = 'none';
        fillEl.style.width = prevFill + '%';
        void fillEl.offsetWidth;
        fillEl.style.transition = '';
        fillEl.style.width = target + '%';
      }

      if (prevLevel !== null && level > parseInt(prevLevel, 10) && el.dataset.confetti === 'true') {
        setTimeout(function () { confetti(el); }, 350);
      }

      store(KEY_FILL, String(target));
      store(KEY_LEVEL, String(level));
    });
  }

  /* ---------- Minuteur (modes keep / delivery / offer) ---------- */
  var KEY_TIMER_END = 'poofy:timer:end';
  var KEY_TIMER_COUNT = 'poofy:timer:count';

  function local(key, value) {
    try {
      if (value === undefined) return localStorage.getItem(key);
      if (value === null) localStorage.removeItem(key);
      else localStorage.setItem(key, value);
    } catch (e) {
      return null;
    }
  }

  // Mode "keep" : une seule échéance partagée, conservée d'une page à l'autre
  function initKeepTimer(el) {
    var count = parseInt(el.dataset.count, 10) || 0;
    var durationMs = (parseInt(el.dataset.duration, 10) || 20) * 60000;
    var reset = el.dataset.reset === 'true';
    var now = Date.now();
    var end = parseInt(local(KEY_TIMER_END), 10) || 0;
    var prevCount = parseInt(local(KEY_TIMER_COUNT), 10) || 0;

    if (count === 0) {
      local(KEY_TIMER_END, null);
    } else if (!end || (reset && count > prevCount) || end - now > durationMs) {
      local(KEY_TIMER_END, String(now + durationMs));
    }
    local(KEY_TIMER_COUNT, String(count));
  }

  // Jours fériés français (fixes + Pâques, Ascension, Pentecôte) pour une année donnée
  var holidayCache = {};
  function frenchHolidays(year) {
    if (holidayCache[year]) return holidayCache[year];
    // Dimanche de Pâques (algorithme de Meeus/Jones/Butcher)
    var a = year % 19, b = Math.floor(year / 100), c = year % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31) - 1, day = ((h + l - 7 * m + 114) % 31) + 1;
    var easter = new Date(year, month, day);
    var plus = function (n) { return new Date(year, easter.getMonth(), easter.getDate() + n); };
    var list = [
      new Date(year, 0, 1), new Date(year, 4, 1), new Date(year, 4, 8), new Date(year, 6, 14),
      new Date(year, 7, 15), new Date(year, 10, 1), new Date(year, 10, 11), new Date(year, 11, 25),
      plus(1), plus(39), plus(50) // lundi de Pâques, Ascension, lundi de Pentecôte
    ];
    holidayCache[year] = list.map(function (x) { return x.toDateString(); });
    return holidayCache[year];
  }

  // Ajoute n jours de livraison : dimanche et jours fériés exclus, samedi selon l'option
  function addBusinessDays(date, n, withSaturday) {
    var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day === 0 || (day === 6 && !withSaturday)) continue;
      if (frenchHolidays(d.getFullYear()).indexOf(d.toDateString()) !== -1) continue;
      added++;
    }
    return d;
  }

  // Heure limite : 0 = minuit. Avant l'heure limite, la commande compte pour aujourd'hui, sinon pour demain.
  function cutoffInfo(el) {
    var h = parseInt(el.dataset.cutoff, 10) || 0;
    var n = new Date();
    var todayCut = new Date(n.getFullYear(), n.getMonth(), n.getDate(), h, 0, 0);
    if (h === 0) {
      return { base: n, end: new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1).getTime() };
    }
    if (n < todayCut) return { base: n, end: todayCut.getTime() };
    return {
      base: new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1),
      end: new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1, h, 0, 0).getTime()
    };
  }

  function formatDay(d) {
    return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'long' });
  }

  function initDeliveryDates(el) {
    var min = parseInt(el.dataset.min, 10) || 6;
    var max = Math.max(min, parseInt(el.dataset.max, 10) || 14);
    var info = cutoffInfo(el);
    var sat = el.dataset.saturday === 'true';
    var minEl = el.querySelector('[data-poofy-date-min]');
    var maxEl = el.querySelector('[data-poofy-date-max]');
    if (minEl) minEl.textContent = formatDay(addBusinessDays(info.base, min, sat));
    if (maxEl) maxEl.textContent = formatDay(addBusinessDays(info.base, max, sat));
    el.dataset.day = String(info.end);
  }

  /* Fenêtres d'événement. Soldes : dates légales France calculées automatiquement
     (été : dernier mercredi de juin, ou l'avant-dernier s'il tombe après le 28 ;
      hiver : 2e mercredi de janvier, ou le 1er s'il tombe après le 12 ; durée 4 semaines, début 8h). */
  var EVENT_NAMES = { soldes_ete: "Soldes d'été", soldes_hiver: "Soldes d'hiver", black_friday: 'Black Friday' };

  function parseDate(str) {
    var t = Date.parse((str || '').trim().replace(' ', 'T'));
    return isNaN(t) ? 0 : t;
  }

  function wednesdayOf(year, month, fromDay, step) {
    var d = new Date(year, month, fromDay);
    while (d.getDay() !== 3) d.setDate(d.getDate() + step);
    return d;
  }

  function eventWindow(el) {
    var type = el.dataset.eventType || 'custom';
    var year = new Date().getFullYear();
    var start, end, d;
    if (type === 'soldes_ete') {
      d = wednesdayOf(year, 5, 30, -1);
      if (d.getDate() > 28) d.setDate(d.getDate() - 7);
    } else if (type === 'soldes_hiver') {
      d = wednesdayOf(year, 0, 1, 1);
      d.setDate(d.getDate() + 7);
      if (d.getDate() > 12) d.setDate(d.getDate() - 7);
    }
    if (d) {
      start = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 8, 0, 0).getTime();
      end = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 27, 23, 59, 59).getTime();
    } else if (type === 'black_friday' && !el.dataset.eventEnd) {
      var fri = new Date(year, 10, 1);
      while (fri.getDay() !== 5) fri.setDate(fri.getDate() + 1);
      fri.setDate(fri.getDate() + 21);
      start = fri.getTime();
      end = new Date(fri.getFullYear(), fri.getMonth(), fri.getDate() + 3, 23, 59, 59).getTime();
    } else {
      start = parseDate(el.dataset.eventStart);
      end = parseDate(el.dataset.eventEnd);
    }
    var name = EVENT_NAMES[type] || el.dataset.eventName || '';
    return { start: start || 0, end: end || 0, name: name };
  }

  function activeEvent() {
    var timers = document.querySelectorAll('[data-poofy-promo-event]');
    var now = Date.now();
    for (var i = 0; i < timers.length; i++) {
      var w = eventWindow(timers[i]);
      if (timers[i].dataset.forceHidden !== 'true' && w.end && now >= w.start && now < w.end) {
        w.el = timers[i];
        return w;
      }
    }
    return null;
  }

  function syncEventBadges(ev) {
    document.querySelectorAll('[data-poofy-event-badge]').forEach(function (b) {
      b.hidden = !ev || b.dataset.forceHidden === 'true';
      if (ev) b.querySelectorAll('[data-poofy-event-name]').forEach(function (n) { n.textContent = ev.name; });
    });
    // Pendant un événement avec code (bouton Appliquer / Appliqué), le lien « Un code promo ? » est inutile
    var eventHasCode = !!(ev && ev.el.querySelector('[data-poofy-apply-code], .poofy-promo-event__applied'));
    document.querySelectorAll('[data-poofy-code-link]').forEach(function (d) {
      if (d.hidden !== eventHasCode) d.hidden = eventHasCode;
    });
    // Promo non cumulable sans code (ex. Black Friday automatique) : les paliers ne s'appliqueraient pas
    var hideTiers = !!(ev && ev.el.dataset.hideTiers === 'true');
    document.querySelectorAll('[data-poofy-tiers]').forEach(function (t) {
      t.classList.toggle('is-event-hidden', hideTiers);
    });
  }

  function timerEnd(el) {
    if (el.dataset.mode === 'delivery') return cutoffInfo(el).end;
    return parseInt(local(KEY_TIMER_END), 10) || 0;
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function renderValue(el, remainMs) {
    var total = Math.max(0, Math.ceil(remainMs / 1000));
    var d = Math.floor(total / 86400);
    var h = Math.floor((total % 86400) / 3600);
    var m = Math.floor((total % 3600) / 60);
    var sec = total % 60;
    var parts;
    if (el.dataset.mode === 'keep') parts = [[pad(Math.floor(total / 60)), 'min'], [pad(sec), 'sec']];
    else if (d > 0) parts = [[String(d), 'j'], [pad(h), 'h'], [pad(m), 'min'], [pad(sec), 'sec']];
    else parts = [[pad(h), 'h'], [pad(m), 'min'], [pad(sec), 'sec']];

    if (el.dataset.style === 'chips') {
      return parts.map(function (p) {
        return '<span class="poofy-timer__chip">' + p[0] + '<small>' + p[1] + '</small></span>';
      }).join('<span class="poofy-timer__sep">:</span>');
    }
    if (d > 0) return parts[0][0] + ' j ' + parts.slice(1).map(function (p) { return p[0]; }).join(':');
    return parts.map(function (p) { return p[0]; }).join(':');
  }

  function initTimers(root) {
    var els = (root || document).querySelectorAll('[data-poofy-timer]:not([data-poofy-ready])');
    els.forEach(function (el) {
      el.setAttribute('data-poofy-ready', '');
      if (el.dataset.mode === 'keep') initKeepTimer(el);
      if (el.dataset.mode === 'delivery') initDeliveryDates(el);
    });
    tickTimers();
  }

  /* ---------- Événement promo (bloc séparé) : affiché uniquement pendant sa période ---------- */
  function tickEvents() {
    var now = Date.now();
    document.querySelectorAll('[data-poofy-promo-event]').forEach(function (el) {
      var w = eventWindow(el);
      var on = !!w.end && now >= w.start && now < w.end;
      el.hidden = !on || el.dataset.forceHidden === 'true';
      if (!on) return;
      el.querySelectorAll('[data-poofy-event-name]').forEach(function (n) { n.textContent = w.name; });
      var endText = new Date(w.end).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit' });
      el.querySelectorAll('[data-poofy-event-end]').forEach(function (n) {
        if (n.textContent !== endText) n.textContent = endText;
      });
      var value = el.querySelector('[data-poofy-timer-value]');
      if (value) {
        var html = renderValue(el, w.end - now);
        if (value.innerHTML !== html) value.innerHTML = html;
      }
    });
    syncEventBadges(activeEvent());
  }

  function tickTimers() {
    tickEvents();
    var els = document.querySelectorAll('[data-poofy-timer]');
    if (!els.length) return;
    var now = Date.now();
    els.forEach(function (el) {
      if (el.dataset.mode === 'delivery' && el.dataset.day !== String(cutoffInfo(el).end)) initDeliveryDates(el);
      var end = timerEnd(el);
      var remain = Math.max(0, end - now);
      var isExpired = end > 0 && remain === 0;
      var value = el.querySelector('[data-poofy-timer-value]');
      var running = el.querySelector('[data-poofy-timer-running]');
      var expired = el.querySelector('[data-poofy-timer-expired]');
      if (value) {
        var html = renderValue(el, remain);
        if (value.innerHTML !== html) value.innerHTML = html;
      }
      if (running) running.hidden = isExpired && !!expired;
      if (expired) expired.hidden = !isExpired;
    });
  }
  setInterval(tickTimers, 1000);

  /* ---------- Sélecteur de variante dans le panier ---------- */
  function sectionHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function refreshDrawer(sections) {
    if (!sections) return window.location.reload();
    var drawerHtml = sections['cart-drawer'] && sectionHTML(sections['cart-drawer'], '#CartDrawer');
    var drawer = document.getElementById('CartDrawer');
    if (drawer && drawerHtml !== null) drawer.innerHTML = drawerHtml;
    var bubble = document.getElementById('cart-icon-bubble');
    var bubbleHtml = sections['cart-icon-bubble'] && sectionHTML(sections['cart-icon-bubble'], '.shopify-section');
    if (bubble && bubbleHtml !== null) bubble.innerHTML = bubbleHtml;
  }

  function onVariantChange(select) {
    var newId = parseInt(select.value, 10);
    var line = parseInt(select.dataset.line, 10);
    var key = select.dataset.key;
    var qty = parseInt(select.dataset.qty, 10) || 1;
    if (!key || !newId || String(newId) === select.dataset.current) return;
    var properties = {};
    try { properties = JSON.parse(select.dataset.properties || '{}'); } catch (e) {}
    // Liquid sérialise « aucune propriété » en [] : add.js le refuse (400), il faut un objet
    if (!properties || typeof properties !== 'object' || Array.isArray(properties)) properties = {};
    select.disabled = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    var sectionsParams = { sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname };

    // Une seule unité change de variante : avec une quantité de 2+, la ligne se scinde en deux.
    // On ajoute d'abord la nouvelle variante, et on ne retire l'unité de l'ancienne ligne qu'après succès :
    // si l'ajout échoue (stock, erreur), le panier reste intact.
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ items: [{ id: newId, quantity: 1, properties: properties }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        // Shopify place l'article ajouté en tête du panier : on retrouve l'ancienne ligne par sa clé, pas par son rang
        return fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(Object.assign({ id: key, quantity: qty - 1 }, sectionsParams))
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); })
      .then(function (data) {
        refreshDrawer(data && data.sections);
        document.dispatchEvent(new CustomEvent('poofy:cart-variant-changed', { detail: { line: line, variantId: newId } }));
      })
      .catch(function () {
        // Échec : le panier n'a pas été modifié (ou seulement complété), on réaffiche l'état réel
        select.value = select.dataset.current;
        select.disabled = false;
        fetch(root + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); })
          .then(refreshDrawer)
          .catch(function () { window.location.reload(); });
      });
  }

  document.addEventListener('change', function (e) {
    var select = e.target.closest && e.target.closest('[data-poofy-variant-select]');
    if (select) onVariantChange(select);
  });

  /* ---------- Codes promo : bouton « Appliquer » de l'événement + lien « Un code promo ? » ---------- */
  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // API Ajax du panier (champ discount) : renvoie le panier et le tiroir re-rendu
  function postCode(code) {
    return fetch(shopRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) { if (!r.ok) throw new Error('update'); return r.json(); });
  }

  // Secours : le lien /discount/CODE pose le code dans le panier, puis on recharge le tiroir
  function fallbackCode(code) {
    var root = shopRoot();
    return fetch(root + 'discount/' + encodeURIComponent(code))
      .then(function () { return fetch(root + '?sections=cart-drawer,cart-icon-bubble'); })
      .then(function (r) { return r.json(); })
      .then(refreshDrawer)
      .catch(function () { window.location.reload(); });
  }

  function applyCode(btn) {
    var code = btn.dataset.poofyApplyCode;
    if (!code || btn.disabled) return;
    btn.disabled = true;
    postCode(code)
      .then(function (data) {
        if (!data || !data.sections) throw new Error('sections');
        refreshDrawer(data.sections);
      })
      .catch(function () { fallbackCode(code); });
  }

  function submitCodeForm(form) {
    var input = form.querySelector('input');
    var btn = form.querySelector('button');
    var error = form.parentNode.querySelector('[data-poofy-code-error]');
    var code = (input.value || '').trim();
    if (!code || btn.disabled) return;
    btn.disabled = true;
    if (error) error.hidden = true;
    var refuse = function () {
      btn.disabled = false;
      if (error) error.hidden = false;
      input.focus();
    };
    postCode(code)
      .then(function (data) {
        var found = (data.discount_codes || []).filter(function (d) {
          return (d.code || '').toUpperCase() === code.toUpperCase();
        })[0];
        if (!found || !found.applicable) return refuse();
        if (!data.sections) throw new Error('sections');
        refreshDrawer(data.sections);
      })
      .catch(refuse);
  }

  // Retire un code du panier (seulement celui-là : les autres codes éventuels restent), puis redessine le tiroir
  function removeCode(btn) {
    if (btn.disabled) return;
    btn.disabled = true;
    var target = (btn.dataset.poofyRemoveCode || '').toUpperCase();
    var root = shopRoot();
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var keep = (cart.discount_codes || []).map(function (d) { return d.code; }).filter(function (c) {
          return !target || c.toUpperCase() !== target;
        });
        return postCode(keep.join(','));
      })
      .then(function (data) {
        if (!data || !data.sections) throw new Error('sections');
        refreshDrawer(data.sections);
      })
      .catch(function () { window.location.reload(); });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('[data-poofy-remove-code]');
    if (rm) { e.preventDefault(); removeCode(rm); return; }
    var btn = e.target.closest && e.target.closest('[data-poofy-apply-code]');
    if (!btn) return;
    e.preventDefault();
    applyCode(btn);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-poofy-code-form]');
    if (!form) return;
    e.preventDefault();
    submitCodeForm(form);
  });

  function initAll(root) {
    initTiers(root);
    initTimers(root);
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      initAll(document);
    });
  }

  window.PoofyCart = { init: initAll, confetti: confetti };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
})();
